module.exports = __webpack_public_path__ + "static/aerial-views-xiv-6c7b770f4e3ac967bf18ffbc2fb22ddb.jpg";